import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { api, formatTL } from "@/lib/api";

export const CarryWarningPanel = ({ yil, ay, refreshKey, onOpen }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    let live = true;
    api.get(`/advances/carry-warnings?yil=${yil}&ay=${ay}`).then((r) => live && setRows(r.data.rows || [])).catch(() => live && setRows([]));
    return () => { live = false; };
  }, [yil, ay, refreshKey]);
  if (!rows.length) return null;
  return (
    <div className="max-w-[1600px] mx-auto px-6 pt-4" data-testid="carry-warning-panel">
      <div className="border border-amber-300 bg-amber-50 rounded-xl px-4 py-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-amber-900">
          <AlertTriangle size={15} className="text-amber-600" />
          <span data-testid="carry-warning-count">{rows.length} personelin primden kesilen avansı 2 aydır veya daha uzun süredir devrediyor</span>
          <button type="button" onClick={onOpen} data-testid="carry-warning-open" className="ml-auto text-xs font-bold text-amber-800 hover:underline">Avanslara git</button>
        </div>
        <div className="mt-2 flex flex-wrap gap-2">
          {rows.map((r) => (
            <span key={r.id} className="text-xs bg-white border border-amber-200 rounded-md px-2 py-1" data-testid={`carry-warning-row-${r.sicil_no}`}>
              <strong>{r.ad_soyad}</strong> · {r.devir_ay} ay · devir {formatTL(r.devir)} · kalan {formatTL(r.kalan)}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
